import { Component, inject } from '@angular/core';
import { AboutUsComponent } from '../about-us/about-us.component';
import { PrivacyComponent } from '../privacy/privacy.component';
import { TermsComponent } from '../terms/terms.component';
import { BaseComponent } from "@nucleus/ui-base";
import { SupportComponent } from '../support/support.component';
import { ApplicationConfigService } from '../../services/application-config.service';
import { AppInterceptorService } from '../../services/app-interceptor.service';

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrl: './footer.component.css',
    standalone: false
})
export class FooterComponent extends BaseComponent {

  appConfig: ApplicationConfigService = inject(ApplicationConfigService);

  constructor() {
    super();
  }

  showAbout() {
    this.dialog.open(AboutUsComponent, {
      panelClass: 'bw-dialog-panel',
      width: '680px',
      maxWidth: '90vw',
      maxHeight: '85vh'
    });
  }

  showPrivacy() {
    this.dialog.open(PrivacyComponent, {
      panelClass: 'bw-dialog-panel',
      width: '680px',
      maxWidth: '90vw',
      maxHeight: '85vh'
    });
  }

  showTerms() {
    this.dialog.open(TermsComponent, {
      panelClass: 'bw-dialog-panel',
      width: '680px',
      maxWidth: '90vw',
      maxHeight: '85vh'
    });
  }

  showSupport() {
    this.dialog.open(SupportComponent, {
      panelClass: 'bw-dialog-panel',
      width: '520px',
      maxWidth: '90vw',
      autoFocus: false,
      data: {
        userEmail: this.appConfig.getUserId(),
        tenant: this.appConfig.getUserId(),
        sessionId: AppInterceptorService.getOrCreateSessionId(),
        appVersion: localStorage.getItem('version')
      }
    });
  }
}
